<wbo-multi-select-control [valueField]="valueField"
                          [labelField]="labelField"
                          [summaryLabelField]="summaryLabelField"
                          [placeholder]="placeholder"
                          [(value)]="value"
                          [sourceSearchModel]="model"
                          [data]="data"
                          (onDataLoaded)="onDataLoaded($event)"
                          [multiObjectValueType]="multiObjectValueType"
                          [labelSearchField]="labelSearchField"
                          [label]="label"
                          (onSelect)="onSelect.emit($event)"
                          (removed)="onRemove()"
                          [attr.id]="elementId"
                          [initialDefaultValue]="initialDefaultValue"
                          [notifyInitialDefault]="notifyInitialDefault"
                          [extendedSearchComponent]="extendedSearchComponent"
                          [extendedEditComponent]="extendedEditComponent">
</wbo-multi-select-control>
